<template style="display: flex">
  <v-container fluid class="px-0">
    <v-overlay :value="add_user">
      <AddUserCard
        v-on:close_add_user="close_add_user"
        :availableUsers="available_users"
      >
      </AddUserCard>
    </v-overlay>
    <v-overlay :value="remove_user">
      <RemoveUserCard
        :user="user_to_remove"
        :org="$auth.user.org_id"
        v-on:close_remove_user="close_remove_user"
        z-index="0"
      />
    </v-overlay>

    <v-card>
      <v-card-title class="black white--text text-h5" style="display: flex">
        <div style="flex: 3">User Directory</div>
        <div style="flex: 1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                style="float: right"
                icon
                v-on="on"
                @click="add_user = true"
              >
                <v-icon color="white">mdi-account-plus</v-icon>
              </v-btn>
            </template>
            <TooltipDescription
              title="Add user to the org"
            ></TooltipDescription>
          </v-tooltip>
        </div>
      </v-card-title>
      <v-row class="pa-4" justify="space-between">
        <v-col cols="5">
          <v-treeview
            :active.sync="active_user"
            :items="org_user_items"
            :load-children="get_org_users"
            activatable
            open-on-click
            transition
          >
            <template v-slot:prepend="{ item }">
              <v-icon v-if="!item.children"> mdi-account </v-icon>
            </template>
          </v-treeview>
        </v-col>

        <v-divider vertical></v-divider>

        <v-col class="d-flex text-center">
          <v-scroll-y-transition mode="out-in">
            <div
              v-if="!selected"
              class="text-h6 grey--text text--lighten-1 font-weight-light"
              style="align-self: center"
            >
              Select a User
            </div>
            <v-col v-else>
              <v-col cols="12" style="display: flex">
                <div style="flex: 3">
                  <div style="float: left">
                    <v-chip
                      label
                      class="data_breakdown_chip"
                      :outlined="selected_tab != 'user_details'"
                      @click="selected_tab = 'user_details'"
                      color="black"
                      >Details</v-chip
                    >
                    <v-chip
                      label
                      class="data_breakdown_chip"
                      :outlined="selected_tab != 'project_access'"
                      @click="selected_tab = 'project_access'"
                      color="black"
                      >Project Access
                    </v-chip>
                  </div>
                </div>
                <div>
                  <v-tooltip bottom v-if="disableAccessEdit">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="disableAccessEdit = !disableAccessEdit"
                      >
                        <v-icon color="black">mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <TooltipDescription
                      title="Enable project access edit"
                    ></TooltipDescription>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="disableAccessEdit = !disableAccessEdit"
                      >
                        <v-icon color="black">mdi-pencil-off-outline</v-icon>
                      </v-btn>
                    </template>
                    <TooltipDescription
                      title="Disable project access edit"
                    ></TooltipDescription>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        :disabled="disableAccessEdit"
                        @click="open_remove_user_confirmation(selected.id)"
                      >
                        <v-icon color="black">mdi-account-remove</v-icon>
                      </v-btn>
                    </template>
                    <TooltipDescription
                      title="Remove user from the organization"
                    ></TooltipDescription>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="save_access"
                        :disabled="disableAccessEdit"
                      >
                        <v-icon color="black">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <TooltipDescription
                      title="Save project access"
                    ></TooltipDescription>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="12">
                <v-col v-if="selected_tab == 'user_details'">
                  <v-card
                    :key="selected.userId"
                    class="pt-6 mx-auto"
                    flat
                    max-width="400"
                  >
                    <v-card-text>
                      <v-avatar size="70px">
                        <img
                          v-if="selected.picture"
                          :alt="selected.name"
                          :src="selected.picture"
                        />
                      </v-avatar>
                      <h3 class="text-h5 mb-2">
                        {{ selected.name }}
                      </h3>
                      <div class="black--text mb-2">
                        {{ selected.email }}
                      </div>
                      <v-divider></v-divider>
                      <div class="black--text mb-2">
                        <b>Account Created: </b>
                        {{ selected.account_created_at }}
                      </div>
                      <div class="black--text mb-2">
                        <b>Last Login: </b> {{ selected.last_login }}
                      </div>
                      <div
                        class="black--text mb-2"
                        style="display: flex; padding-top: 30px"
                      >
                        <span style="width: 40%; margin: auto">
                          <b>Permission Level: </b>
                        </span>
                        <span style="width: 60%">
                          <v-select
                            :disabled="disableAccessEdit"
                            :items="permission_level_options"
                            v-model="userPermissionNew"
                            dense
                            :value="value"
                          ></v-select>
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col v-else-if="selected_tab == 'project_access'">
                  <v-treeview
                    selectable
                    :disabled="disableAccessEdit"
                    v-model="selectedAccessNew"
                    item-disabled="locked"
                    :items="projectAccess"
                    selected-color="primary"
                  >
                  </v-treeview>
                </v-col>
              </v-col>
            </v-col>
          </v-scroll-y-transition>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import admin_api_caller from "@/javascript/user_org_management";
import TooltipDescription from "@/components/Utility/TooltipDescription.vue";
import RemoveUserCard from "../AdminComponents/RemoveUser.vue";
import AddUserCard from "../AdminComponents/AddUser.vue";
import {
  ALERT_GENERIC_MESSAGE,
  ALERT_TYPE_ERROR,
  ALERT_TYPE_SUCCESS,
  SUCCESS_SAVE_PROJECT_ACCESS,
} from "@/constants/constants.js";
export default {
  name: "UserDirectory",
  props: [""],
  components: {
    TooltipDescription,
    RemoveUserCard,
    AddUserCard,
  },

  data: () => ({
    remove_user: false,
    add_user: false,
    user_to_remove: null,
    all_users: {},
    all_org_users: {},
    active_user: [],
    orgUsersList: [],
    selected_tab: "user_details",

    projectAccess: [],
    assignAccess: [],
    removeAccess: [],
    selectedAccess: [],
    selectedAccessNew: [],
    userPermission: "",
    userPermissionNew: "",
    disableAccessEdit: true,
  }),
  async mounted() {
    this.reload_access();
  },
  watch: {
    selected: "userSelected",
  },
  computed: {
    org_user_items() {
      return [
        {
          name: "Users",
          children: this.orgUsersList,
        },
      ];
    },
    permission_level_options() {
      return [
        { text: "Super Admin", value: "SUPER_ADMIN" },
        { text: "Viewer", value: "VIEWER" },
      ];
    },
    selected() {
      if (!this.active_user.length) return undefined;
      const user_id = this.active_user[0];
      return this.orgUsersList.find((user) => user.id === user_id);
    },
    available_users() {
      const available_users = {};

      for (let user_id in this.all_users) {
        if (!this.all_org_users[user_id]) {
          available_users[user_id] = this.all_users[user_id];
        }
      }
      return available_users;
    },
  },

  methods: {
    get_org_users: async function () {
      let token = await this.$auth.getTokenSilently();
      let orgUserResult = await admin_api_caller
        .get_org_users(token, this.$auth.user.org_id)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
      if (orgUserResult) {
        this.all_org_users = orgUserResult;
        this.orgUsersList = [];
        for (let userId in this.all_org_users) {
          this.orgUsersList.push({
            id: userId,
            name: this.all_org_users[userId].name,
            email: this.all_org_users[userId].email,
            last_login:
              this.all_users && this.all_users[userId]
                ? this.all_users[userId]["last_login"]
                : null,
            account_created_at:
              this.all_users && this.all_users[userId]
                ? this.all_users[userId]["account_created_at"]
                : null,
            picture: this.all_org_users[userId].picture,
            permission_level: this.all_org_users[userId].permission_level,
          });
        }
      } else {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      }
    },
    reload_access: async function () {
      if (this.$auth.isAuthenticated) {
        await this.get_all_users();
        await this.get_org_users();
        await this.get_available_access();
      }
    },
    userSelected: function () {
      this.disableAccessEdit = true;
      this.selectedAccess = this.all_org_users[this.selected.id]["access"];
      this.selectedAccessNew = [...this.selectedAccess];
      this.userPermission =
        this.all_org_users[this.selected.id]["permission_level"];
      this.userPermissionNew =
        this.all_org_users[this.selected.id]["permission_level"];
    },
    open_remove_user_confirmation: function (userId) {
      this.user_to_remove = userId;
      this.remove_user = true;
    },
    get_all_users: async function () {
      let token = await this.$auth.getTokenSilently();
      let allUsers = await admin_api_caller
        .get_all_users(token)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
      if (allUsers) {
        this.all_users = allUsers;
      } else {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      }
    },
    get_available_access: async function () {
      let token = await this.$auth.getTokenSilently();

      const payload = { org_id: this.$auth.user.org_id };
      let availableAccess = await admin_api_caller
        .get_available_access(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
      if (availableAccess) {
        this.projectAccess = availableAccess;
      } else {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      }
    },
    save_access: async function () {
      this.disableAccessEdit = true;
      const save_project_access_result = await this.save_project_access();
      const save_permission_result = await this.save_permission_level();

      if (save_project_access_result && save_permission_result) {
        this.$emit(
          "triggerAlert",
          ALERT_TYPE_SUCCESS,
          SUCCESS_SAVE_PROJECT_ACCESS
        );
      } else {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      }
      this.reload_access();
    },
    save_permission_level: async function () {
      const user_id = this.active_user[0];

      if (this.userPermissionNew != this.userPermission) {
        let payload = {
          user_id: user_id,
          permission_level: this.userPermissionNew,
        };

        let token = await this.$auth.getTokenSilently();
        let result = await admin_api_caller
          .update_user_permission(token, payload)
          .then((resp) => {
            if (resp["success"]) {
              return resp["data"];
            }
            return false;
          })
          .catch((e) => {
            console.log(e);
            return false;
          });
        return result;
      }
      return true; // No change in permission level, so return true
    },
    save_project_access: async function () {
      let assign_access = [];
      let remove_access = [];

      const user_id = this.active_user[0];

      this.selectedAccessNew.forEach((access) => {
        if (!this.selectedAccess.includes(access)) {
          assign_access.push(access);
        }
      });

      this.selectedAccess.forEach((access) => {
        if (!this.selectedAccessNew.includes(access)) {
          remove_access.push(access);
        }
      });

      let payload = {
        user_id: user_id,
        assign: assign_access,
        remove: remove_access,
      };

      let token = await this.$auth.getTokenSilently();
      let result = await admin_api_caller
        .assign_user_access(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
      return result;
    },
    close_remove_user: function (alert_type, alert_message) {
      if (alert_type) {
        this.active_user = [];
        this.reload_access();
        this.$emit("triggerAlert", alert_type, alert_message);
      }
      this.user_to_remove = "";
      this.remove_user = false;
    },
    close_add_user: function (alert_type, alert_message) {
      if (alert_type) {
        this.$emit("triggerAlert", alert_type, alert_message);
      }
      this.reload_access();
      this.add_user = false;
    },
  },
};
</script>
<style>
.card-title {
  font-family: "Poppins" !important;
  font-weight: 800 !important;
  font-size: 1.2em !important;
}
.card-section-title {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 1.2em !important;
}
.card-action {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.9em !important;
}
</style>
